import { render, staticRenderFns } from "./user-detail.html?vue&type=template&id=16f4a5ba&scoped=true&"
import script from "./user-detail.js?vue&type=script&lang=js&"
export * from "./user-detail.js?vue&type=script&lang=js&"
import style0 from "./user-detail.css?vue&type=style&index=0&id=16f4a5ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f4a5ba",
  null
  
)

export default component.exports